// extracted by css-extract-rspack-plugin
export default {"formFilter":"PR1gayoWaVAoYBL9","row":"IrklPYtzPC0Eh_6G","field":"EuvJpNWRpiMbIHEC","label":"sRMpt9m2bGcMC3iK","actions":"zQgkjKZBr6YOFAfR"};